import * as React from 'react';
import {withTranslation} from 'react-i18next';
import TurnOffCarForm from "components/CarsManagement/TurnOffCarForm";
import * as VehiclesModule from "Modules/VehiclesModule";
import {compose} from "redux";
import {connect} from "react-redux";
import {Types} from "Models/TerminalInstallationModel";
import TurnOffTerminal = Types.TurnOffTerminal;

type Props = {
    history?: any;
    match: any;
};

type ConnectedProps = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    t?: Function;
};


type DispatchedP = {
    turnOffCar: (formData: any) => void;
    turnOnCar: (carId: number) => void;
    getSingleCar: (carId: number) => void;
};

type State = {};

class TurnOffCar extends React.Component<Props & ConnectedProps & DispatchedP, State> {
    constructor(props: Props & ConnectedProps & DispatchedP) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async componentDidMount() {
        if (this.props.match.params.carId) {
            await this.props.getSingleCar(this.props.match.params.carId);
        }
    }

    public async handleSubmit(formData: TurnOffTerminal) {
        try {
            await this.props.turnOffCar(formData);
        } catch (e) {
            console.log(e);
        }
    }

    public async turnOnCar(carId: number) {
        try {
            await this.props.turnOnCar(carId);
        } catch (e) {
            console.log(e);
        }
    }

    public render() {
        const {vehiclesStore, t} = this.props;

        return (
            <div className="main__content main__content--scroll">
                <h3 className="main__title">{t('turnOffCarTitle')} ({`${vehiclesStore.activeVehicleDetails?.model}/${vehiclesStore.activeVehicleDetails?.vin}`})</h3>

                <div className="flex flex--space-around">
                    <div className="report report-manual">
                        <p className="report-manual__title">{t('dictionary:INSTRUCTION')}</p>
                        <ol className="report-manual__list">
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep1')}}/>
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep2')}}/>
                            <li className="report-manual__list-item"
                                dangerouslySetInnerHTML={{__html: t('turnOffStep3')}}/>
                        </ol>
                    </div>

                    {
                        vehiclesStore.activeVehicleDetails?.turnOffDate ? <div>
                                <div>
                                    Wyłączenie samochodu nastąpi: <span
                                    className="bold">{vehiclesStore.activeVehicleDetails.turnOffDate}</span>
                                </div>
                                <div>
                                    {t('forms:turnOffReason')}: <span
                                    className="bold">{t(`dictionary:${vehiclesStore.activeVehicleDetails.turnOffReason}`)}</span>
                                </div>
                                <div>
                                    {t('forms:turnOffNote')}: <span
                                    className="bold">{vehiclesStore.activeVehicleDetails.turnOffNote}</span>
                                </div>
                            </div> :
                            <TurnOffCarForm initialValues={{carId: vehiclesStore.activeVehicleDetails?.id}}
                                            dateInputName="turnOffDate"
                                            onSubmit={this.handleSubmit}/>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        vehiclesStore: state.vehiclesStore
    };
}


function mapDispatchToProps(dispatch: any): DispatchedP {
    return {
        turnOffCar: (formData: any) => dispatch(VehiclesModule.Actions.turnOffCar(formData)),
        turnOnCar: (carId: number) => dispatch(VehiclesModule.Actions.turnOnCar(carId)),
        getSingleCar: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId))
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation(['carDetails', 'forms', 'dictionary']))(TurnOffCar) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/CarsManagement/TurnOffCar.tsx